import React, { FC } from 'react';
import { ReactComponent as LogoIcon } from '../../assets/logo-icon.svg';
import BorderGradientCircle from '@/components/BorderGradientCircle/BorderGradientCircle';

interface SeatsPreviewProps {
  occupiedSeats: number;
  maxPlayers: number;
}

const SeatsPreview: FC<SeatsPreviewProps> = ({ occupiedSeats, maxPlayers }) => {
  const grayDotClasses = 'h-[0.375em] w-[0.375em] bg-white opacity-30 rounded-full absolute';
  const whiteDotClasses = 'h-[0.375em] w-[0.375em] bg-white rounded-full absolute';
  const numDots = maxPlayers;
  const angleStep = (2 * Math.PI) / numDots;
  const firstDotAngle = maxPlayers === 2 ? (Math.PI * 3) / 4 : Math.PI / 6;

  return (
    <div className="relative flex items-center justify-center text-[16px]">
      {Array.from({ length: numDots }).map((_, index) => {
        const radius = 1.375; // 22px converted to em
        const angle = firstDotAngle + index * angleStep;
        const x = Math.sin(angle) * radius - 0.15625; // 2.5px converted to em
        const y = Math.cos(angle) * radius - 0.15625; // 2.5px converted to em

        return (
          <div
            key={index}
            style={{ top: `calc(50% + ${x}em)`, left: `calc(50% + ${y}em)` }}
            className={index < occupiedSeats ? whiteDotClasses : grayDotClasses}
          />
        );
      })}
      <BorderGradientCircle>
        <LogoIcon className="h-4 w-4" />
        {/* <img
          src={LogoIcon}
          alt="Phenom Poker Logo"
          className="w-full h-full rounded-full"
        /> */}
      </BorderGradientCircle>
    </div>
  );
};

export default SeatsPreview;
